export default __webpack_public_path__ + "static/media/preferr-side-by-side-bf.73674fc5.png";